// extracted by mini-css-extract-plugin
module.exports = {"root":"Blog_root__3BaGT","text":"Blog_text__2B8el","subtitle":"Blog_subtitle__19iBg"};